import { render, staticRenderFns } from "./custom_exclusions.html?vue&type=template&id=432a4af8&scoped=true&external"
import script from "./custom_exclusions.js?vue&type=script&lang=js&external"
export * from "./custom_exclusions.js?vue&type=script&lang=js&external"
import style0 from "./custom_exclusions.scss?vue&type=style&index=0&id=432a4af8&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432a4af8",
  null
  
)

export default component.exports